import { render, staticRenderFns } from "./TopicContent.vue?vue&type=template&id=b0b7db8e&scoped=true&"
import script from "./TopicContent.vue?vue&type=script&lang=js&"
export * from "./TopicContent.vue?vue&type=script&lang=js&"
import style0 from "./TopicContent.vue?vue&type=style&index=0&id=b0b7db8e&lang=scss&scoped=true&"
import style1 from "./TopicContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b7db8e",
  null
  
)

export default component.exports